<script>
export default {
  name: "DialogAddFriends",

  data: () => ({
    url: null,
    callback: () => {},
    showDialog: false,
  }),

  computed: {
    frameDialog() {
      return this.$store.getters["getIFrameAddFriendsDialog"];
    },
  },

  watch: {
    frameDialog() {
      this.showDialog = !!this.frameDialog;

      if (!this.frameDialog) {
        this.clearData();
        return;
      }

      this.setTopIndexToWindow();

      const { url, callback } = this.frameDialog;

      this.$nextTick(() => {
        this.url = url;
      });

      this.callback =
        callback ||
        (() => {
          this.$store.dispatch("hideIFrameAddFriendsDialog", null);
        });
    },
  },

  methods: {
    clearData() {
      this.url = null;
      this.callback = () => {};
    },
    setTopIndexToWindow() {
      setTimeout(() => {
        const dialogContainer = document.querySelector(
          "#add-friends-container",
        );
        const dialogParent = dialogContainer?.parentElement?.parentElement;

        if (dialogContainer && dialogParent) {
          dialogParent.style.top = "50%";
          dialogParent.style.left = "50%";
          dialogParent.style.transform = "translate(-50%, -50%)";
          dialogParent.style.zIndex = "999999";
          dialogParent.style.height = "70%";
          dialogParent.style.width = "70%";
        }
      }, 0);
    },
  },
};
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    content-class="add-friends-dialog black"
    fullscreen
    persistent
    width="100%"
  >
    <div id="add-friends-container" class="w-full h-full">
      <iframe v-if="showDialog" id="dialogFrameAddFriendsId" :src="url"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen frameborder="0"
              height="100%"
              name="addFriendsUrlFrame"
              width="100%" />
      <v-btn class="close-btn-modal" color="primary" text @click="callback()">
        x
      </v-btn>
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
.close-btn-modal {
  top: 10px;
  right: 10px;
}
</style>
